import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Loading";
import { setPeriod, getPeriods } from "../../appRedux/actions/Filters";
import { Radio } from "antd";

const FilterClients = () => {
  const dispatch = useDispatch();

  const currentPeriod = useSelector(({ filtersData }) => filtersData.period.current);
  const dataPeriod = useSelector(({ filtersData }) => filtersData.period);

  useEffect(() => {
    if (!dataPeriod.data) {
      dispatch(getPeriods());
    }
  }, []);

  const onPeriodChange = (e) => {
    dispatch(setPeriod(e.target.value));
  };

  return (
    <>
      {dataPeriod.loading ? (
        <Loading className="gx-my-2" />
      ) : dataPeriod.data ? (
        <Radio.Group onChange={onPeriodChange} buttonStyle="solid">
          {dataPeriod.data.map((period) => {
            let checked = period.key === currentPeriod;
            return (
              <Radio.Button key={period.key} value={period.key} checked={checked} disabled={!period.active}>
                {period.value}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      ) : (
        <div className="gx-my-2">No data</div>
      )}
    </>
  );
};

export default FilterClients;
